export const formTopCal = () => {

    $(function () {
        // ----------------------------------
        // タブを切り替える
        // ----------------------------------
        $("#js-tab li").click(function () {
            $("#js-tab li").removeClass("active");
            $(this).addClass("active");
            var index = $(this).index();

            $(".tab-content").removeClass("active");
            $(".tab-content").eq(index).addClass("active");
        });

        // ----------------------------------
        // モーダルが開いているときにモーダル要素以外の要素を押下したときにモーダルを閉じる処理
        // ----------------------------------
        $(document).on('click', function (e) {
            if ($('body').hasClass('modal-active')) {
                if (!$(e.target).closest('.modal-window').length && !$(e.target).closest('.modal-window--ttl').length && $(e.target).closest('#overlay').length) {
                    $('#overlay, .modal-window, .modal-window--ttl').fadeOut();
                    $('body').removeClass('modal-active');  // 本文の縦スクロールを無効
                }
            }
        });

        // ----------------------------------
        // モーダルをフォーカスで開く
        // ----------------------------------
        $('.js-focus-open').focusin(function () {
            if (!$('body').hasClass('modal-active')) {
                var targetModal = '.' + $(this).data('target');
                var targetModalTtl = '.' + $(this).data('target') + "--ttl";
                $('#overlay, ' + targetModal + ',' + targetModalTtl).fadeIn();
                $('body').addClass('modal-active');  // 本文の縦スクロールを無効
            }
        });



        // ----------------------------------
        // モーダルを閉じるボタンを押下したときの処理
        // ----------------------------------
        $('.js-close').click(function () {
            $('#overlay, .modal-window, .modal-window--ttl').fadeOut();
            $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
        });



        // APIのURLを初期化
        const apiUrl = "https://orikomitry.jp/_app/api";

        // ----------------------------------
        // 地区で使う新聞のデータを取得
        // ----------------------------------
        var paperDatas = []; // 新聞のデータを初期化


        //コンテンツ読み込み
        $.ajax({
            url: apiUrl + '/getPaper',
            dataType: 'json'
        }).done(function (data) {
            paperDatas = data;
            jsClick(paperDatas);
        }).fail(function () {
            console.log('error');
        });

        // ----------------------------------
        // モーダルの要素クリック時の処理（新聞のデータ取得ajaxが終わったら実行）
        // ----------------------------------
        function jsClick(paperDatas) {

            $(".js-click").on('click', function () {
                switch ($(this).data('item')) {
                    // ----------------------------------
                    // モーダルの要素クリック時の処理
                    // ----------------------------------
                    case 'pref1':
                        // ----------------------------------
                        // 都道府県選択1
                        // ----------------------------------
                        $('.js-set-pref1').val($(this).data('pref-name'));
                        $('#overlay, .pref-modal, .pref-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効

                        var prefId = $(this).data('pref-id');

                        $('.js-form1 input[name="prefId"]').val(prefId);


                        $.ajax({
                            url: apiUrl + '/getCity?pref_id=' + prefId,
                            dataType: 'json'
                        }).done(function (data) {
                            
                            var city_el = '';

                            $.each(data['data'], function (index, value) {
                                var paperIds = value['paper_ids'].split(',');

                                city_el += '<li class="js-click js-city1" data-item="city1" data-city-id="' + value['id'] + '" data-city-name="' + value['name'];
                                if (paperIds[0] !== "") {
                                    $.each(paperIds, function (index, value) {
                                        var foundPaper = paperDatas['data'].find(e => e.id === value);
                                        if (foundPaper !== undefined) {
                                            if (foundPaper.name !== undefined) {
                                                city_el += ' ' + foundPaper.name;
                                            }
                                        }
                                    })
                                }
                                city_el += '">' + value['name'];
                                
                                if (paperIds[0] !== "") {
                                    $.each(paperIds, function (index, value) {
                                        var foundPaper = paperDatas['data'].find(e => e.id === value);
                                        if (foundPaper !== undefined) {
                                            if (foundPaper.name !== undefined) {
                                                city_el += '<div class="paper-label-content">' + '<span class="paper-label">' + foundPaper.name + '</span>' + '</div>';
                                            }
                                        }
                                    })
                                }

                            })
                            city_el += '</li>';

                            $(".js-city-datas1").html(city_el);


                        }).fail(function () {
                            console.log('error');
                        });
                        $('.js-set-city1').val('');
                        break;

                    case 'sheet1':
                        // ----------------------------------
                        // チラシ枚数選択1
                        // ----------------------------------
                        $('.js-set-sheet1').val($(this).data('sheet-num'));
                        $('.js-form1 input[name="sheetId"]').val($(this).data('sheetId'));
                        $('#overlay, .sheet-modal, .sheet-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効

                        break;

                    case 'size1':
                        // ----------------------------------
                        // サイズ選択1
                        // ----------------------------------
                        $('.js-set-size1').val($(this).data('size'));
                        $('.js-form1 input[name="sizeId"]').val($(this).data('sizeId'));
                        $('#overlay, .size-modal, .size-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
                        break;

                    case 'pref2':
                        // ----------------------------------
                        // 都道府県選択2
                        // ----------------------------------
                        $('.js-set-pref2').val($(this).data('pref-name'));
                        $('#overlay, .pref-modal, .pref-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効

                        var prefId = $(this).data('pref-id');

                        $('.js-form3 input[name="prefId"]').val(prefId);


                        $.ajax({
                            url: apiUrl + '/getCity?pref_id=' + prefId,
                            dataType: 'json'
                        }).done(function (data) {
                            var city_el = '';

                            $.each(data['data'], function (index, value) {
                                var paperIds = value['paper_ids'].split(',');

                                city_el += '<li class="js-click js-city2" data-item="city2" data-city-id="' + value['id'] + '" data-city-name="' + value['name'];
                                if (paperIds[0] !== "") {
                                    $.each(paperIds, function (index, value) {
                                        var foundPaper = paperDatas['data'].find(e => e.id === value);
                                        if (foundPaper !== undefined) {
                                            if (foundPaper.name !== undefined) {
                                                city_el += ' ' + foundPaper.name;
                                            }
                                        }
                                    })
                                }
                                city_el += '">' + value['name'];

                                $.each(paperIds, function (index, value) {
                                    var foundPaper = paperDatas['data'].find(e => e.id === value);
                                    city_el += '<div class="paper-label-content">' + '<span class="paper-label">' + foundPaper.name + '</span>' + '</div>';

                                })
                            })

                            $(".js-city-datas2").html(city_el);
                        }).fail(function () {
                            console.log('error');
                        });
                        $('.js-set-city2').val('');
                        break;

                    case 'sheet2':
                        // ----------------------------------
                        // チラシ枚数選択2
                        // ----------------------------------
                        $('.js-set-sheet2').val($(this).data('sheet-num'));
                        $('.js-form3 input[name="sheetId"]').val($(this).data('sheetId'));
                        $('#overlay, .sheet-modal, .sheet-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
                        break;

                    case 'size2':
                        // ----------------------------------
                        // サイズ選択2
                        // ----------------------------------
                        $('.js-set-size2').val($(this).data('size'));
                        $('.js-form3 input[name="sizeId"]').val($(this).data('sizeId'));
                        $('#overlay, .size-modal, .size-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
                        break;
                    case 'distance1':
                        // ----------------------------------
                        // 配信距離1
                        // ----------------------------------
                        $('.js-set-sumakomi-distance1').val($(this).data('distance1'));
                        $('#overlay, .sumakomi-distance-modal, .sumakomi-distance-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
                        break;
                    case 'distance2':
                        // ----------------------------------
                        // 配信距離1
                        // ----------------------------------
                        $('.js-set-sumakomi-distance2').val($(this).data('distance2'));
                        $('#overlay, .sumakomi-distance-modal, .sumakomi-distance-modal--ttl').fadeOut();
                        $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
                        break;
                }



            });

        }



        // ----------------------------------
        // 動的に生成したcity1要素をクリックしたときの処理
        // ----------------------------------
        $(document).on('click', '.js-city1', function () {
            $('.js-set-city1').val($(this).data('city-name'));
            $('.js-form1 input[name="cityId"]').val($(this).data('cityId'));
            $('#overlay, .city-modal, .city-modal--ttl').fadeOut();
            $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
        });
        // ----------------------------------
        // 動的に生成したcity2要素をクリックしたときの処理
        // ----------------------------------
        $(document).on('click', '.js-city2', function () {
            $('.js-set-city2').val($(this).data('city-name'));
            $('.js-form3 input[name="cityId"]').val($(this).data('cityId'));
            $('#overlay, .city-modal, .city-modal--ttl').fadeOut();
            $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
        });
        // ----------------------------------
        // フォーム送信のバリデーションチェック（js-form1）
        // ----------------------------------
        $(".js-form1").submit(function () {
            // エラーの個数を初期化
            var err = 0;

            if ($(".js-form1 input[name='pref']").val() == '') {
                $('.js-form1 .js-err-msg--pref').removeClass('is-none');
                err++;
            } else {
                $('.js-form1 .js-err-msg--pref').addClass('is-none');
            }

            if ($(".js-form1 input[name='city']").val() == '') {
                $('.js-form1 .js-err-msg--city').removeClass('is-none');
                err++;
            } else {
                $('.js-form1 .js-err-msg--city').addClass('is-none');
            }

            if ($(".js-form1 input[name='sheet']").val() == '') {
                $('.js-form1 .js-err-msg--sheet').removeClass('is-none');
                err++;
            } else {
                $('.js-form1 .js-err-msg--sheet').addClass('is-none');
            }

            if ($(".js-form1 input[name='size']").val() == '') {
                $('.js-form1 .js-err-msg--size').removeClass('is-none');
                err++;
            } else {
                $('.js-form1 .js-err-msg--size').addClass('is-none');
            }


            if (err > 0) {
                return false;
            }
        });
        // ----------------------------------
        // フォーム送信のバリデーションチェック（js-form2）
        // ----------------------------------
        $(".js-form2").submit(function () {
            // エラーの個数を初期化
            var err = 0;

            if ($(".js-form2 input[name='sumakomiMoney']").val() == '') {
                $('.js-form2 .js-err-msg--sumakomi-money').removeClass('is-none');
                err++;
            } else {
                $('.js-form2 .js-err-msg--sumakomi-money').addClass('is-none');
            }

            if ($(".js-form2 input[name='sumakomiArea']").val() == '') {
                $('.js-form2 .js-err-msg--sumakomi-area').removeClass('is-none');
                err++;
            } else {
                $('.js-form2 .js-err-msg--sumakomi-area').addClass('is-none');
            }

            if ($(".js-form2 input[name='sumakomiDistance']").val() == '') {
                $('.js-form2 .js-err-msg--sumakomi-distance').removeClass('is-none');
                err++;
            } else {
                $('.js-form2 .js-err-msg--sumakomi-distance').addClass('is-none');
            }

            if (err > 0) {
                return false;
            }
        });
        // ----------------------------------
        // フォーム送信のバリデーションチェック（js-form3）
        // ----------------------------------
        $(".js-form3").submit(function () {
            // エラーの個数を初期化
            var err = 0;

            // ----------------------------------
            // 新聞折込
            // ----------------------------------
            if ($(".js-form3 input[name='pref']").val() == '') {
                $('.js-form3 .js-err-msg--pref').removeClass('is-none');
                err++;
            } else {
                $('.js-form3 .js-err-msg--pref').addClass('is-none');
            }

            if ($(".js-form3 input[name='city']").val() == '') {
                $('.js-form3 .js-err-msg--city').removeClass('is-none');
                err++;
            } else {
                $('.js-form3 .js-err-msg--city').addClass('is-none');
            }

            if ($(".js-form3 input[name='sheet']").val() == '') {
                $('.js-form3 .js-err-msg--sheet').removeClass('is-none');
                err++;
            } else {
                $('.js-form3 .js-err-msg--sheet').addClass('is-none');
            }

            if ($(".js-form3 input[name='size']").val() == '') {
                $('.js-form3 .js-err-msg--size').removeClass('is-none');
                err++;
            } else {
                $('.js-form3 .js-err-msg--size').addClass('is-none');
            }

            // ----------------------------------
            // スマホ折込
            // ----------------------------------
            if ($(".js-form3 input[name='sumakomiMoney']").val() == '') {
                $('.js-form3 .js-err-msg--sumakomi-money').removeClass('is-none');
                err++;
            } else {
                $('.js-form3 .js-err-msg--sumakomi-money').addClass('is-none');
            }

            if ($(".js-form3 input[name='sumakomiArea']").val() == '') {
                $('.js-form3 .js-err-msg--sumakomi-area').removeClass('is-none');
                err++;
            } else {
                $('.js-form3 .js-err-msg--sumakomi-area').addClass('is-none');
            }

            if ($(".js-form3 input[name='sumakomiDistance']").val() == '') {
                $('.js-form3 .js-err-msg--sumakomi-distance').removeClass('is-none');
                err++;
            } else {
                $('.js-form3 .js-err-msg--sumakomi-distance').addClass('is-none');
            }

            if (err > 0) {
                return false;
            }
        });

        // ----------------------------------
        // スマホ折込ヘルプボタンを押下したときの処理
        // ----------------------------------
        $(".js-sp-help-btn").on('click', function () {
            if ($('.js-sp-help-modal').hasClass('active')) {
                $('#overlay, .js-sp-help-modal').fadeOut();
                $('.js-sp-help-modal').addClass('active');
                $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
            } else {
                $('#overlay, .js-sp-help-modal').fadeIn();
                $('.js-sp-help-modal').removeClass('active');
                $('body').addClass('modal-active');  // 本文の縦スクロールを無効
            }
        });




    });

};